<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary"
              class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>Products list</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
      <div class="p-6">
        <vs-button @click="importProducts" v-if="products.length===0 && !progress" class="mb-6" style="width: 100%">
          Import products
        </vs-button>
        <!--Table-->
        <vs-table v-model="selected" ref="table" pagination :max-items="itemsPerPage" search
                  :data="products">
          <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
            <!-- Items per page -->
            <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
              <div
                  class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{
                currentPage * itemsPerPage - (itemsPerPage - 1)
              }} - {{ products.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : products.length }} de {{
                queriedItems
              }}</span>
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
              </div>
              <vs-dropdown-menu>

                <vs-dropdown-item @click="itemsPerPage=10">
                  <span>10</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage=20">
                  <span>20</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage=30">
                  <span>30</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage=40">
                  <span>40</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>

          <template slot="thead">
            <vs-th sort-key="order">Order</vs-th>
            <vs-th sort-key="name">Name</vs-th>
            <vs-th sort-key="category">Brand</vs-th>
            <vs-th sort-key="stock">Price</vs-th>
            <vs-th sort-key="price">Country</vs-th>
            <vs-th sort-key="brand">LBS</vs-th>
            <vs-th>Availability</vs-th>
          </template>

          <template slot-scope="{data}">
            <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                <vs-input style="width: 50px" v-model.number="tr.order" type="number"></vs-input>
              </vs-td>

              <vs-td>
                <p class="product-name font-medium truncate">{{ tr.name }}</p>
              </vs-td>

              <vs-td>
                <p class="product-name font-medium truncate">{{ tr.brand.name }}</p>
              </vs-td>

              <vs-td>
                <vs-input style="width: 80px" v-model.number="tr.price" type="number"></vs-input>
              </vs-td>

              <vs-td>
                <p class="product-name font-medium truncate">{{ tr.country.name }}</p>
              </vs-td>

              <vs-td>
                <p class="product-name font-medium truncate">{{ tr.size }}</p>
              </vs-td>

              <vs-td>
                <vs-switch @input="switchState(tr)" v-model="tr.state"/>
              </vs-td>
            </vs-tr>
            </tbody>
          </template>
        </vs-table>
      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid || progress">Save</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
      <div v-if="progress" style="margin-top: 1rem; width: 100%">
        <vs-progress indeterminate color="primary"></vs-progress>
      </div>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Datepicker from 'vuejs-datepicker'
import trimString from "../../mixins/trimString"
import vSelect from 'vue-select'

const firebase = require("firebase")
// Required for side-effects
require("firebase/firestore")
let db = firebase.firestore()
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {
      }
    }
  },
  components: {
    VuePerfectScrollbar,
    Datepicker,
    vSelect
  },
  mixins: [trimString],
  data() {
    return {
      itemsPerPage: 40,
      selected: {},
      client: {},
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      progress: false,
      products: []
    }
  },
  watch: {
    async isSidebarActive(val) {
      if (val) {
        this.progress = true
        this.client = {
          ...this.data
        }
        this.products = []
        this.$validator.reset()
        await this.getProducts()
        this.progress = false
      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive
      },
      set(val) {
        if (!val) {
          this.$emit('closeSidebar')
        }
      }
    },
    isFormValid() {
      return !this.errors.any()
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag
    },
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    queriedItems() {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.products.length
    }
  },
  mounted() {
    this.isMounted = true
  },
  methods: {
    async submitData() {
      try {
        this.progress = true
        const batch = firebase.firestore().batch()
        this.products.forEach((p) => {
          const docRef = firebase.firestore().collection('clients').doc(this.client.id).collection('products').doc(p.id)
          p.price = parseFloat(p.price)
          batch.update(docRef, {
            ...p
          })
        })
        await batch.commit()
        this.$vs.notify({
          color: 'success',
          title: 'Products',
          text: 'Products updated successfully.'
        })
        this.$emit('closeSidebar')
      } catch (e) {
        this.$vs.notify({
          color: 'warning',
          title: '¡Oh no!',
          text: 'There was a mistake.'
        })
      } finally {
        this.progress = false
      }
    },
    /**
     * Get products
     */
    async getProducts() {
      try {
        const querySnap = await firebase.firestore().collection('clients').doc(this.client.id).collection('products').get()
        querySnap.forEach((doc) => {
          const obj = {
            id: doc.id,
            ...doc.data()
          }
          this.products.push(obj)
        })
      } catch (e) {
        this.$vs.notify({
          color: 'warning',
          title: '¡Oh no!',
          text: 'There was a mistake.'
        })
      }
    },
    /**
     * Chage state of product
     * @param product
     */
    switchState(product) {
      let productRef = db.collection('clients').doc(this.client.id).collection('products').doc(product.id)
      productRef.update({
        state: product.state
      }).then(() => {
        this.$vs.notify({
          color: 'success',
          title: 'Product',
          text: 'The modification was applied.'
        })
      }).catch(() => {
        this.$vs.notify({
          color: 'success',
          title: '¡Oh no!',
          text: 'There was a mistake.'
        })
      })
    },
    // Import products for client
    async importProducts() {
      try {
        this.progress = true
        const products = []
        const batch = firebase.firestore().batch()
        const querySnap = await db.collection("products").get()
        querySnap.forEach((doc) => {
          const obj = {
            id: doc.id,
            ...doc.data()
          }
          const docRef = firebase.firestore().collection('clients').doc(this.client.id).collection('products').doc(obj.id)
          batch.set(docRef, {
            ...obj
          })
          products.push(obj)
        })
        await batch.commit()
        this.products = [...products]
      } catch (e) {
        console.log(e)
        this.$vs.notify({
          color: 'warning',
          title: '¡Oh no!',
          text: 'There was a mistake.'
        })
      } finally {
        this.progress = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 90vw;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
